
import { AssetsUserDetailsEntityDecoratorBase } from './assets-user-details.decorator.base';


export class AssetsUserDetailsEntityDecorator extends AssetsUserDetailsEntityDecoratorBase {
  constructor() {
    super();
  }
}



